import  { useEffect, useState } from 'react'
import ConsumerInfoView from './ConsumerInfoView/ConsumerInfoView'
import { useConsumption } from '../../../hooks'
import { useFilter } from '../../../../filter/hook'

export default function ConsumerInfoPresenter({defaultDeviceEui}: {defaultDeviceEui?: string}) {
  const {consunptionQuery:{isLoading}} = useConsumption()
  const {filter, setFilter} = useFilter()
  const [devEui, setDevEui] = useState(defaultDeviceEui)
  useEffect(() => {
    if(filter.device_name && filter.device_name !== '') {
      setDevEui(filter.device_name)
    }

    if(defaultDeviceEui && defaultDeviceEui !== '') {
      setDevEui(defaultDeviceEui)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {

    if(defaultDeviceEui && defaultDeviceEui !== '') {
      setDevEui(defaultDeviceEui)

    }
  },[defaultDeviceEui]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = () => {

    if (devEui !== '') {
      setFilter({
        ...filter,
        device_name: devEui
      })


    }
  }
  
  return (
    <ConsumerInfoView
      isLoading={isLoading}
      currentDevEui={filter.device_name || undefined}
      devEuiValue={devEui}
      onSubmit={handleSubmit}
      setDevEuiValue={setDevEui}
      />
  )
}
